import { InterviewRequestState } from './types';

export const state: InterviewRequestState = {
  // Sitter Data
  sitter: null,
  sitterUuid: null,

  // Basic Details
  startTime: null,
  endTime: null,
  virtual: null,
  address: null,
  geoPointX: null,
  geoPointY: null,

  // Family Details
  jobTitle: null,
  jobUuid: null,
  careType: null,
  details: null,
};

export default state;
